import { FileDropzone } from "components/FileDropzone";

const MAX_DELIVERY_FILES = 10;

interface Props {
  files: File[];
  onFilesChange: (files: File[]) => void;
}

export function DeliveryFileUploadDropzone(props: Props) {
  const { files, onFilesChange } = props;
  return (
    <FileDropzone
      files={files}
      onFilesChange={onFilesChange}
      maxFiles={MAX_DELIVERY_FILES}
    />
  );
}
